import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { withProcessingLogic } from "../../../utils/utils.domain";
import { EStatus } from "../../../../constants";
import { produce } from "../../../../libs/immer";
import { formatValue, unformatValue } from "../components/PaymentSelection/components/PaymentDetailsSection/InputSection/components/SumInput/utils";
import { setPopupIsOpenUseCase } from "./openPopup.case";
export var checkUrlPaymentStatusUseCase = function checkUrlPaymentStatusUseCase(_ref) {
  var checkUrl = _ref.checkUrl;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getState, setState) {
      var _yield$withProcessing, result, _ref3, status, sum, statusPopup;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            result = checkUrl(function () {
              setPopupIsOpenUseCase(true, setState);
            }, setState);
            if (result) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return");
          case 4:
            setPopupIsOpenUseCase(true, setState);
            _context.next = 7;
            return withProcessingLogic(setState)(result);
          case 7:
            _context.t1 = _yield$withProcessing = _context.sent;
            _context.t0 = _context.t1 !== null;
            if (!_context.t0) {
              _context.next = 11;
              break;
            }
            _context.t0 = _yield$withProcessing !== void 0;
          case 11:
            if (!_context.t0) {
              _context.next = 15;
              break;
            }
            _context.t2 = _yield$withProcessing;
            _context.next = 16;
            break;
          case 15:
            _context.t2 = {};
          case 16:
            _ref3 = _context.t2;
            status = _ref3.status;
            sum = _ref3.sum;
            statusPopup = status;
            setState(produce(function (draft) {
              draft.statusPopup = statusPopup;
              if (!sum) return;
              draft.sumInput.value = formatValue(unformatValue(sum));
            }));
            _context.next = 27;
            break;
          case 23:
            _context.prev = 23;
            _context.t3 = _context["catch"](0);
            console.error(_context.t3);
            setState(produce(function (draft) {
              draft.statusPopup = EStatus.Error;
            }));
          case 27:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 23]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};